import { ref, computed } from 'vue'
import emailValidator from 'foundation/js/inputValidators/emailValidator'

export default {
    name: 'PreFooter',
    setup() {
        const emailInput = ref()
        const consentCheckbox = ref(false)

        const isValidEmail = computed(
            emailValidator.bind(null, emailInput.value)
        )

        const readyToSubmit = computed(() => {
            return consentCheckbox.value && isValidEmail
        })

        const sendInfomationToServer = function () {
            if (readyToSubmit.value) {
                console.log(
                    'Send information via XHR to server:',
                    emailInput.value
                )
            }
        }

        return {
            consentCheckbox,
            emailInput,
            isValidEmail,
            sendInfomationToServer
        }
    }
}
